import React, { useEffect } from 'react'
import Link from 'next/link'
import Head from 'next/head'
import { useIonModal } from '@ionic/react'
import HowItWorksModal from '../components/HowItWorksModal'
import PageTitle from '../components/PageTitle'
import { setPageViewData } from '../utils/analytics'

const Help: React.FC = () => {
  useEffect(() => {
    setPageViewData('Other|Customer Service', 'Other', 'Customer Service')
  }, [])

  const handleDismiss = () => {
    dismiss()
  }
  const [present, dismiss] = useIonModal(HowItWorksModal, {
    handleDismiss,
    clickedElement: 'Customer Service'
  })

  return (
    <div id="main-content">
      <Head>
        <title>Help</title>
        <meta name="description" content="We're here to help, please reach out to our customer service team." />
      </Head>
      <PageTitle title="help" />
      <section className="help-page" id="help">
        <div className="help-page__container">
          <h2>customer support</h2>
          <p>
            Right now, pOpshelf® is offering in-store pickup for online orders. If you need to speak to someone on
            our customer support team, please reach out here:
          </p>
          <p><strong>Phone:</strong> <a href="tel:+18333774353">833-3PSHELF (833-377-4353)</a></p>
          <p><strong>Email:</strong> <a href="mailto:customercare@pOpshelf.com">customercare@pOpshelf.com</a></p>
          <p><strong>Media Inquiries:</strong> <a href="mailto:pr@pOpshelf.com">pr@pOpshelf.com</a></p>

          <h2>helpful links</h2>
          <div className="help-page__links">
            <p>Have questions about returns? Check out the <Link href="/termsandconditions#returns" tabIndex={0}>Returns Policy</Link> section of our T&Cs.</p>
            <p>Do you need to check the status of an order? Visit the <Link href="/orders" tabIndex={0}>My Orders</Link> area.</p>
            <p>Would you like to find the nearest pOpshelf® location? <Link href="/stores" tabIndex={0}>Search for stores</Link> to find out if there's a store nearby.</p>
            <p>Want to know more about how in-store pickup works? <a tabIndex={0} onClick={() => present({ cssClass: 'modal--fullscreen' })}>Check out this quick list.</a></p>
            <p>Want to check the balance on a gift card? Visit our gift card <a target="_blank" rel="noreferrer" href="https://popshelf.myretailcard.com/">site</a>.</p>
          </div>
        </div>
      </section>
    </div>
  )
}

export const getServerSideProps = async () => {
  return {
    props: {}
  }
}

export default Help
